import { slideToggle, slideUp } from '../helpers';

export function initDetailsAnimation(container = '', allOpen = true) {
	if (!container) {
		container = document;
	}

	const details = container.querySelectorAll('details');
	details.forEach((detail) => {
		const content = detail.querySelector('.details-content');
		if (content) {
			detail.classList.add('cursor-pointer');
			detail.setAttribute('open', '');
			content.classList.add('hidden');
			detail.addEventListener('click', function (e) {
				// Close all other details
				if (!allOpen) {
					const siblings = detail.parentNode.querySelectorAll('details');
					siblings.forEach((sibling) => {
						if (!sibling.contains(e.target)) {
							slideUp(sibling.querySelector('.details-content'));
							sibling.classList.remove('open');
						}
					});
				}

				if (!content.contains(e.target)) {
					e.preventDefault();
					slideToggle(content);
					detail.classList.toggle('open');
				}
			});
		}
	});
}
